module.exports = __webpack_public_path__ + "img/battery-4.d8c2d48d.svg";